import React from 'react';
import classNames from 'classnames';
import './SlideoutContent.scss';
import { Spin } from 'antd';

const Empty = () => (
  <div className="slideout-content__empty">Nothing found</div>
);

type Props = {
  children?: React.ReactNode;
  className?: string;
  busy?: boolean;
};

export const SlideoutContent = ({ className, children, busy }: Props) => {
  let content = children || <Empty />;
  if (busy) {
    content = <Spin tip="Loading..." className="slideout-content__spin" />;
  }

  if (Array.isArray(children)) {
    if (!children.length) content = <Empty />;
  }

  return (
    <div className={classNames(className, 'slideout-content')}>{content}</div>
  );
};
